"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestBinanceCoinmClient = void 0;
const shared_1 = require("./shared");
const lossless_json_1 = require("lossless-json");
class RestBinanceCoinmClient extends shared_1.RestBinanceClient {
    static load(params) {
        return new RestBinanceCoinmClient(params);
    }
    getOpenOrdersRaw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v1/openOrders', {
                transformResponse: [
                    (res) => {
                        const customParsed = (0, lossless_json_1.parse)(res);
                        return JSON.parse(res).map((order, index) => {
                            return (0, shared_1.orderIdParser)(order, index, customParsed ? customParsed : '');
                        });
                    }
                ]
            });
        });
    }
    getAccountInformationRaw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v1/account');
        });
    }
    getPositionInformationRaw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v1/positionRisk');
        });
    }
    getExchangeInfoRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePublic.get('/dapi/v1/exchangeInfo');
        });
    }
    getSymbolPriceTicker(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePublic.get('/dapi/v1/ticker/price');
        });
    }
    getCurrentPositionMode() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v1/positionSide/dual');
        });
    }
    getAdlQuantileEstimation() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v1/adlQuantile');
        });
    }
    getLeverageBracket(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.axiosServicePrivate.get('/dapi/v2/leverageBracket', {
                params: params
            });
        });
    }
}
exports.RestBinanceCoinmClient = RestBinanceCoinmClient;
